 <div (click)="search()"  [style.background-image]="'url('+section.image?.url+')'"  class="section-card" [ngClass]="{
    'product-card--layout--grid product-card--size--sm': layout === 'grid-sm',
    'product-card--layout--grid product-card--size--nl': layout === 'grid-nl',
    'product-card--layout--grid product-card--size--lg': layout === 'grid-lg',
    'product-card--layout--list':                        layout === 'list',
    'product-card--layout--horizontal':                  layout === 'horizontal'
}">
    <div style="height: 333px; width: 100%;" class="flex flex-col justify-between content-center">
        <span class="section-name m-2 text-center">{{translateHelper.localize(section?.name) }}</span>
       <!--  <a (click)="search()" class=" section-name m-2 underline">Search</a> -->
    </div>
</div>
